import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ViewProject } from 'src/app/web/interfaces/project/list/viewProjectDto';

@Component({
  selector: 'app-document-popup-project',
  templateUrl: './document-popup-project.component.html',
  styleUrls: ['./document-popup-project.component.scss']
})
export class DocumentPopupProjectComponent implements OnInit {

  closeResult = '';
  filterProjectInfoDto: ViewProject = {} as ViewProject

  @ViewChild('defaultTabButtons')
  public defaultTabButtonsTpl: TemplateRef<any>;
  
  constructor(config: NgbModalConfig, private modalService: NgbModal) {

    config.backdrop = 'static';
    config.keyboard = false;
   }

  ngOnInit(): void {

  }
   
  public open(itemEnd: ViewProject) {

    this.filterProjectInfoDto = itemEnd
    
    this.modalService.open(this.defaultTabButtonsTpl, { ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
